module.exports = __webpack_public_path__ + "img/go_search.20467f22.svg";